import { useEffect, useRef, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
// The premium card used by the listing/home pages — replaces the old
// Material-UI popup card so the map matches the rest of the site.
import EventCard from "../../shared/components/EventCard";
import EventPoint from "./EventPoint";
import * as API from "../../api";


const MapPoint = (props) => {
  const [opened, setIsOpened] = useState(false);
  const handleOnOpen = () => setIsOpened(true);
  const handleOnClose = () => setIsOpened(false);
  const containerRef = useRef(null);

  const getPrice = (prices = []) => {
    let filteredPrices = prices.filter((item) => item.default == "1");
    if (filteredPrices.length > 0) {
      let price = filteredPrices[0].price;
      return API.priceFormat(price);
    } else {
      return 0;
    }
  };

  // Hook for handle outside click - simple implementation from stack overflow
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpened(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);

  return (
    <div ref={containerRef}>
      {opened ? (
        // The premium EventCard renders its own layout/price, so the popup
        // only needs to position it and provide the close affordance.
        <div className="relative z-[1001] w-[260px]">
          <button
            type="button"
            onClick={handleOnClose}
            aria-label="Fermer"
            className="absolute -right-2 -top-2 z-10 flex h-7 w-7 items-center justify-center rounded-full border border-slate-200 bg-white text-ink-muted shadow-card transition-colors hover:text-ink"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
          <EventCard event={props.event} width={null} className="w-full" />
        </div>
      ) : (
        <EventPoint
          name={props.event.title}
          price={getPrice(props.event.prices)}
          onClick={handleOnOpen}
        />
      )}
    </div>
  );
};

export default MapPoint;
